module.exports = __webpack_public_path__ + "img/hong_kong_2016_2.c7ff36f5.png";